import "./AboutUs.scss"
import {useEffect, useState} from "react";

const AboutUsSection = () => {

  const [isHalfScreen, setIsHalfScreen] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 768) {
        setIsHalfScreen(false);
      }
      else setIsHalfScreen(true);
    };

    // Set initial state based on current window width
    handleResize();

    // Add event listener for window resize
    window.addEventListener('resize', handleResize);

    // Cleanup event listener on component unmount
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <section className="section aboutUs">
      <div className="content">
        <h1 className="aboutUs-title">
          We're a small team aiming large <span className="target">targets</span>
        </h1>
        <div className="team-tech">
          {isHalfScreen ? (
            <>
              <div className="half-screen-container">
                <p className="left-text">
                  We believe tech should work efficiently to allow space and time for people to work better and less
                </p>
                <div className="circles">
                  <div className="team">
                    <div className="circle">team</div>
                  </div>
                  <div className="cross">
                    <div className="vertical"></div>
                    <div className="horizontal"></div>
                  </div>
                  <div className="tech">
                    <div className="circle">tech</div>
                  </div>
                </div>
                <p className="right-text">
                  Empathy navigates what we do: we want to help you solve your everyday tasks better, faster, easier
                </p>
              </div>
              <div className="label-aboutUs">
                <div className="labels">
                  <div className="label lb-1">empathic</div>
                  <div className="label lb-2">efficient</div>
                  <div className="label lb-3">easy</div>
                  <div className="label lb-4">earthly</div>
                  <div className="label lb-5">friendly</div>
                  <div className="label lb-6">minimalistic</div>
                </div>
              </div>
            </>
          ) : (
            <>
              <div className="circles">
                <div className="team">
                  <div className="circle">team</div>
                </div>
                <div className="cross">
                  <div className="vertical"></div>
                  <div className="horizontal"></div>
                </div>
                <div className="tech">
                  <div className="circle">tech</div>
                </div>
              </div>
              <div className="label-aboutUs">
                <div className="labels">
                  <div className="label lb-1">empathic</div>
                  <div className="label lb-2">efficient</div>
                  <div className="label lb-3">easy</div>
                  <div className="label lb-4">earthly</div>
                  <div className="label lb-5">friendly</div>
                  <div className="label lb-6">minimalistic</div>
                </div>
              </div>
              <div className="text-aboutUs">
                <p className="left-text">
                  We believe tech should work efficiently to allow space and time for people to work better and less
                </p>
                <p className="right-text">
                  Empathy navigates what we do: we want to help you solve your everyday tasks better, faster, easier
                </p>
              </div>
            </>
          )}
        </div>
      </div>
    </section>
  )
}

export default AboutUsSection;